
              const Handlebars = require('handlebars');
              const templateFunction = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  return "<div class=\"search-spinner\">\n    <span class=\"material-symbols-outlined\">\n        sync\n    </span>\n</div>\n";
  },"useData":true});
              Handlebars.templates['src/hbs/partials/spinner.hbs'] = templateFunction;
              export default templateFunction;
              